import React from 'react';
import MapSettings from './components/MapSettings';

const Settings = () => {
    return (
        <MapSettings />
    )
}

export default Settings;